import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

import { useAppSelector } from '../../hooks';

interface DownloadContextToggleProps {
  readonly mode: 'single' | 'custom' | 'bulk';
  readonly onChangeMode: (mode: 'single' | 'custom' | 'bulk') => void;
  readonly singularDownloadsDisabled?: boolean;
}

export function DownloadContextToggle({ mode, onChangeMode, singularDownloadsDisabled }: DownloadContextToggleProps) {
  const openContextType = useAppSelector((state) => state.application.openContext?.type);

  return (
    <ToggleButtonGroup
      exclusive
      fullWidth
      sx={{ whiteSpace: 'nowrap' }}
      size="small"
      value={mode}
      onChange={(_, value: 'single' | 'custom' | 'bulk' | null) => {
        if (value === mode || value == null) return;
        onChangeMode(value);
      }}
    >
      <ToggleButton value="bulk" sx={{ px: 2 }}>
        {openContextType === 'project' ? 'Whole Project' : 'All Components'}
      </ToggleButton>

      <ToggleButton value="custom" sx={{ px: 2 }}>
        Custom
      </ToggleButton>

      <ToggleButton value="single" disabled={singularDownloadsDisabled} sx={{ px: 2 }}>
        Single Component
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
